import { DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Store } from '@ngxs/store'
import { filter, of, take, timeout } from 'rxjs'
import { defaultFlags } from './feature-flags'
import { FeatureFlagState } from './store'

// Default time to wait for feature flag to load before labeling it loaded
export const FEATURE_FLAG_LOAD_TIMEOUT_MS = 5000

// Helper function check when feature flags are loaded (!= default flags)
// Will be used to help with the initial load of the public & court apps
// TODO: Will be removed once public/court is fully released
export function observeFeatureFlagsLoaded(
  store: Store,
  destroyRef: DestroyRef,
  onLoaded: () => void,
  // Timeout added to handle scenarios where launch darkly is down
  timeoutMs = FEATURE_FLAG_LOAD_TIMEOUT_MS,
): void {
  store
    .select(FeatureFlagState.allFeatureFlags)
    .pipe(
      filter(flags => flags !== defaultFlags),
      take(1),
      timeout({ first: timeoutMs, with: () => of(undefined) }),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe(() => onLoaded())
}
